import { put, PutEffect, select, SelectEffect, takeEvery } from 'redux-saga/effects';

import { selectAllElementsOfType } from 'js/actionCreators/selectionActions';
import { ExistingScribeModel } from 'js/types';
import { setActiveElements } from 'js/actionCreators/scribeActions';

import { getProjectById } from './selectors';

function* handleSelectAllElementsOfType({
  payload
}: ReturnType<typeof selectAllElementsOfType>): Generator<
  SelectEffect | PutEffect,
  void,
  ExistingScribeModel | undefined
> {
  const project = yield select(getProjectById, payload.projectId);
  if (!project) return;

  const activeScene = project.scenes.find(scene => scene.active);
  if (!activeScene) return;

  const sceneElements = project.elements.filter(element => activeScene.elementIds.includes(element.id));
  const elementIdsOfType = sceneElements
    .filter(element => element.type === payload.elementType)
    .map(element => element.id);

  if (elementIdsOfType.length > 0) {
    yield put(setActiveElements(elementIdsOfType));
  }
}

export default function* selectionSagas() {
  yield takeEvery(selectAllElementsOfType.type, handleSelectAllElementsOfType);
}
